import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpaContext } from '../../../Classes/spacontext';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { SignableDocumentType } from '../../../Common/Models/Api/Constants/SignableDocumentType';
import { SignatureDocuments } from '../../Models/Client/SignatureDocuments';

@Injectable()
export class UsageAgreementsService {
	readonly baseUri = '/Api/Client/v2/units';

	constructor(
		private http: VisibaApiHttp,
		private _spaContext: SpaContext,
	) {}

	public getSignatureDocuments(licenceHolderId: number): Observable<ApiResponse<SignatureDocuments>> {
		let params = new HttpParams();
		params = params.append('licenceHolderId', licenceHolderId.toString());

		return this.http.getTyped<SignatureDocuments>(`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/UsageAgreements`, true, {
			params,
		});
	}

	public signDocument(type: SignableDocumentType, langCode: string): Observable<ApiResponse<void>> {
		const sendModel = {
			Type: type,
			LanguageCode: langCode,
		};

		return this.http.post(`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/UsageAgreements`, sendModel);
	}
}
